import apiClient from './client';
import type { Session, CreateSessionRequest, CreateSessionResponse } from '@/types/session';

/**
 * 获取所有会话列表。
 */
export async function getSessions(): Promise<Session[]> {
  const response = await apiClient.get<Session[]>('/sessions');
  return response.data as unknown as Session[];
}

/**
 * 创建新会话。
 * @param data 可选标题
 */
export async function createSession(data?: CreateSessionRequest): Promise<CreateSessionResponse> {
  const response = await apiClient.post<CreateSessionResponse>('/sessions', data || {});
  return response.data as unknown as CreateSessionResponse;
}

/**
 * 获取单个会话详情。
 * @param id 会话 ID
 */
export async function getSession(id: string): Promise<Session> {
  const response = await apiClient.get<Session>(`/sessions/${id}`);
  return response.data as unknown as Session;
}

/**
 * 删除会话。
 * @param id 会话 ID
 */
export async function deleteSession(id: string): Promise<void> {
  await apiClient.delete(`/sessions/${id}`);
}
